<template>
  <div id="data">
    <v-container class="py-10">
      <div align="left" class="mb-3">{{ description }}</div>
      <v-row v-for="x in contant" :key="x.title">
        <v-col cols="12" class="my-3" align="left">
          <div class="font-weight-bold text-h5">{{ x.title }}</div>
          <div v-html="x.sub"></div>
        </v-col>
      </v-row>
    </v-container>
    <div class="py-16"></div>
    <div class="py-16"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageName: "免責聲明",
      description:
        "歡迎使用「小芋頭服務」 (以下簡稱本網站)，本網站重視每一個使用者所享有的服務，特此向您說明本網站的使用政策，以保障您的權益。",
      contant: [
        {
          title: "一、免責聲明",
          sub: "本網站有權隨時更改資料，資料之更改係由本網站單方決定而不會再另行通知。雖然本網站已盡力確保所載資料之準確性，但本網站不會明示或隱含保證該等資料均為準確無誤。本網站不會對任何錯誤或遺漏承擔責任。<br/><br/>本網站不會對使用或任何人士使用本網站而導致之任何損害（包括但不限於電腦病毒、系統固障、資料損失）承擔任何民事、刑事或行政法律上的賠償之責。本網站所內含可能連結至其他機構或第三人所架設、提供的網頁或程式，但這些網頁或程式並非本網站所能控制、管理及維護，任何瀏覽本網站的人士，須自行承擔一切風險，本網站不會負責任何因瀏覽或使用本網站而引致之損失。本網站不會作出任何默示的擔保。",
        },
        {
          title: "二、免責聲明更新",
          sub: "無論本網站給予或不給予事先通知下，本網站均保留隨時更新本免責聲明的權利，任何更改於本網站發佈時，立即生效。每次瀏覽本網站前，煩請務必查看此免責聲明。如繼續使用本網站，即代表同意接受更改後的免責聲明約束。",
        },
        {
          title: "三、版權 ",
          sub: "本網站的所有資料屬本網站專屬財產，受知識產權法例及權利（包括但不限於保護版權的法例）所保障。根據此法例及權利，任何未經授權使用的資料屬侵權行為。在未經本網站明確同意下，本網站資料之全部或部份不可被使用、複印、銷售、傳送、修改、發表、儲存或以其他方式利用作任何用途。",
        },
        {
          title: "四、責任限制",
          sub: "在任何情況下，本網站不須為任何人由於使用本網站，並因內容上或任何產品、資訊或服務，而招致的任何損失或損害，負上任何責任（不論基於合約、侵權行為、疏忽、或其他方面）。您可在本網站建立活動報名及其活動費用顯示，僅為本網站提供您做為活動及費用紀錄，您及其會員本身間的交流，需由您自行承擔風險及損失。在不限制以上條文的一般性之原則及任何情況下，使用本網站的任何附帶引起、特殊或相應而生之任何種類的損害作出賠償，包括但不限於利潤損失、營業受阻、營業資料損失或其他經濟損失、人身傷害或死亡。",
        },
        {
          title: "五、一般性賠償",
          sub: "您同意，若由於您違反本免責聲明及∕或使用本網站或服務的關係或原因，令本網站及本網站招致或蒙受任何損失、索償、法律責任、損害、要求、費用及支出（包括所有的律師費用），閣下將為本網站及本網站抗辯、對本網站及本網站作出賠償，及保障本網站及本網站不受損害。",
        },
        {
          title: "六、服務變更、中斷或終止",
          sub: "鑒於網路服務的特殊性，您同意本網站有權隨時變更、中斷或終止部分或全部的網路服務。",
        },
        {
          title: "七、法律管轄",
          sub: "本使用條款的訂立、執行和解釋及爭議的解決均應適用於中華民國法律，並以台灣高雄地方法院作為第一審管轄法院。",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
